var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4754 12.475C16.1318 11.8186 16.5005 10.9283 16.5005 10.0001C16.5005 9.07183 16.1318 8.18159 15.4754 7.52522C14.819 6.86884 13.9288 6.50009 13.0005 6.50009C12.0723 6.50009 11.182 6.86884 10.5256 7.52522C9.86926 8.18159 9.50051 9.07183 9.50051 10.0001C9.50051 10.9283 9.86926 11.8186 10.5256 12.475C11.182 13.1313 12.0723 13.5001 13.0005 13.5001C13.9288 13.5001 14.819 13.1313 15.4754 12.475Z",
    stroke: "#878787",
    strokeWidth: 1.89383,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.86816 9.99998C3.3545 5.26681 7.77733 1.83331 13.0005 1.83331C18.2248 1.83331 22.6465 5.26681 24.1328 9.99998C22.6465 14.7331 18.2248 18.1666 13.0005 18.1666C7.77733 18.1666 3.3545 14.7331 1.86816 9.99998Z",
    stroke: "#878787",
    strokeWidth: 1.89383,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEye);
export default __webpack_public_path__ + "static/media/icon-eye.e823f2050dea64f89341a32f149b1b35.svg";
export { ForwardRef as ReactComponent };